export const SET_INITIAL_USER = 'SET_INITIAL_USER';
export const REMOVE_USER_DATA = 'REMOVE_USER_DATA';
